export default __webpack_public_path__ + "static/media/arrow-curved-dashed-line.f177422f.svg";